import React from "react";

import {
  Card,
  CardTitle,
  CardBody,
  CardImg,
  CardText,
  Row,
  Col,
  Button,
  Label,
  Input,
  FormGroup
} from "reactstrap";
import { Textbox, Checkbox } from "react-inputs-validation";
import "../../styles/estilos.css";
import Page from "components/Page";
import ImgExitoso from "assets/img/PENDING.png";
import ValoresCotizacion from "./ValoresCotizacion";
import ListadoProductos from "./ListaProductosCotizacion/ListadoProductos";
import { withRouter } from "react-router-dom";
import { infoIds } from "../../constants";

class Cotizacion5ConfirmacionFinalError extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      placa: "",
      validate: false,
      hasPlacaError: true,
      chasis: this.props.datosCotizacion.datosPlaca.chasis
    };
    this.metodo = this.metodo.bind(this);
  }

  toggleValidating(validate) {
    this.setState({ validate });
  }
  metodo(e){
    e.preventDefault();
    if(this.props.estado === "PENDIENTE")
    {
      this.props.history.replace({
        pathname: "/lista-cotizadores",
      });
      // this.props.history.replace({
      //   pathname: "/cotizacion",
      //   search: `?accion=nuevo`
      // });// Para ir a la pantalla de ramos y no permitirle regresar mediante el navegador
    }  
  }

  render() {
    const { validate, placa, chasis } = this.state;
    const { datosCotizacion } = this.props;
    let{carDatosContratante,carDatosPagadorFacturacion,_id, TransaccionesPago}=this.props.datosCarrito.productosCarrito;
    if(carDatosContratante===undefined || carDatosContratante===null ){
      carDatosContratante={
        id: "",
        cliNombre1: "",
        cliApellido1: "",
        cliEmail: "",
        cliCelular: "",
        empCodigo: "",
        cliNombre2: "",
        cliApellido2: "",
        cliIdentificacion: "",
        cliTelefono: "",
        cliDireccion: "",
        cliFechaNacimiento: "",
        cliCiudad: "",
        cliProvincia: "",
        cliPais: "",
        cliCodGenero: "1",
        cliGenero: "",
        cliCodigoCiudad: "1",
        cliCodigoProvincia: "1",
        cliCodigoPais: "",
        cliCodigoTipoDocumento: infoIds.codigoCedulaStr,
        cliTipoDocumento: "",
        cliCodigoEstadoCivil: "",
        cliEstadoCivil: "",
        cliFechaEmisionPasaporte: null,
        cliFechaCaducidadPasaporte: null,
        cliFechaIngresoPais: null,
        cliPersoneria: ""
    
    }
  }

  if(carDatosPagadorFacturacion ===undefined || carDatosPagadorFacturacion ===null ){
    carDatosPagadorFacturacion ={
      id: "",
      cliNombre1: "",
      cliApellido1: "",
      cliEmail: "",
      cliCelular: "",
      empCodigo: "",
      cliNombre2: "",
      cliApellido2: "",
      cliIdentificacion: "",
      cliTelefono: "",
      cliDireccion: "",
      cliFechaNacimiento: "",
      cliCiudad: "",
      cliProvincia: "",
      cliPais: "",
      cliCodGenero: "1",
      cliGenero: "",
      cliCodigoCiudad: "1",
      cliCodigoProvincia: "1",
      cliCodigoPais: "",
      cliCodigoTipoDocumento: infoIds.codigoCedulaStr,
      cliTipoDocumento: "",
      cliCodigoEstadoCivil: "",
      cliEstadoCivil: "",
      cliFechaEmisionPasaporte: null,
      cliFechaCaducidadPasaporte: null,
      cliFechaIngresoPais: null,
      cliPersoneria: ""
  
  }
}
else{
  carDatosPagadorFacturacion=carDatosPagadorFacturacion[0];
}
    return (
      <Page
        title="Cotización de vehículos"
        breadcrumbs={[{ name: "cotización de vehículos", active: true }]}
      >
        <Row>
          <Col lg={8} md={12} sm={12} xs={12}>
            <div className="container-step">
              <div className="wrapper-step">
                <div className="arrow-steps clearfix-step">
                  <div className="step">
                    {" "}
                    <span>1. Cotización</span>{" "}
                  </div>
                  <div className="step">
                    {" "}
                    <span>2. Resumen</span>{" "}
                  </div>
                  <div className="step current">
                    {" "}
                    <span>3. Confirmación</span>{" "}
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
        <Row>
          <Col
            lg={8}
            md={12}
            sm={12}
            xs={12}
            className="detalle-cotizacion-box"
          >
            <Card className="flex-row">
              <CardBody>
                <Row>
                  <Col lg={8} md={8} sm={8} xs={12}>
                    <div style={{ padding: "1em" }}>
                      <h2 style={{ color: "#001871" }}> EN PROCESO</h2>
                      <h5> {`Tu transacción esta en proceso en unos minutos recibirás un correo electrónico de confirmación del pago. Tu ${this.props.datosUsuario.usu_tipo_usuario && this.props.datosUsuario.usu_tipo_usuario !== 'cliente'?"venta":"compra"} es la # ${this.props.datosCarrito.productosCarrito.carIdTransaccionPago}`}.</h5>
                      {this.props.datosCarrito.productosCarrito.TransaccionesPago && this.props.datosCarrito.productosCarrito.TransaccionesPago.traPagoId &&  
                        <h5 style={{ textAlign: "justify" }}> {`Referencia del Pago # ${this.props.datosCarrito.productosCarrito.TransaccionesPago && this.props.datosCarrito.productosCarrito.TransaccionesPago.traPagoId?this.props.datosCarrito.productosCarrito.TransaccionesPago.traPagoId:""}`}.</h5>
                      }
                      {/*
                        <h5 style={{ textAlign: "justify" }}> {`Estado: ${TransaccionesPago && TransaccionesPago.traEstadoPlacetoPay ? TransaccionesPago.traEstadoPlacetoPay : ''}`}</h5>
                      */}
                      {this.props.datosCarrito.productosCarrito.TransaccionesPago && this.props.datosCarrito.productosCarrito.TransaccionesPago.traEstadoPago &&  
                        <h5 style={{ textAlign: "justify" }}> {`Estado del Pago: ${this.props.datosCarrito.productosCarrito.TransaccionesPago && this.props.datosCarrito.productosCarrito.TransaccionesPago.traEstadoPago?this.props.datosCarrito.productosCarrito.TransaccionesPago.traEstadoPago:""}`}</h5>
                      }
                      <h5>A continuación los detalles de tu {this.props.datosUsuario.usu_tipo_usuario && this.props.datosUsuario.usu_tipo_usuario !== 'cliente'?"venta.":"compra."}</h5>
                    </div>
                  </Col>
                  <Col
                    lg={4}
                    md={4}
                    sm={4}
                    xs={12}
                    style={{ textAlign: "center" }}
                  >
                    <img src={ImgExitoso} width="100px"></img>
                  </Col>
                </Row>
              </CardBody>
            </Card>


    
       {this.props.datosCarrito.productosCarrito.carProductos !== undefined && this.props.datosCarrito.productosCarrito.carProductos.map((carrito, index) => (
              <ListadoProductos datosCotizacion={carrito} indice={index} origen="final-cotizacion"/>
            ))}


            <Card className="flex-row ">
              <CardBody>


                <Row>
                  <Col lg={8} md={8} sm={8} xs={12}>
                    <h4 style={{ fontWeight: "bold" }}>Datos del Contratante</h4>
                    <p />
                  </Col>

                </Row>

                <Row style={{display:"none"}}>
                  <Col lg={4} md={4} sm={4} xs={12}>
                    <h5>Seleccione personería</h5>
                  </Col>
                  <Col lg={8} md={8} sm={8} xs={12}>
               {`${carDatosContratante.cliNombre1} ${carDatosContratante.cliNombre2}`}
                                        </Col>
                                        </Row>



                                        <Row>
                  <Col lg={4} md={4} sm={4} xs={12}>
                    <h5>Tipo de documento</h5>
                  </Col>
                  <Col lg={8} md={8} sm={8} xs={12}>
                  {`${carDatosContratante.cliTipoDocumento} `}
                                        </Col>
                                        </Row>


                <Row>
                  <Col lg={4} md={4} sm={4} xs={12}>
                    <h5>Número de Identificación</h5>
                  </Col>
                  <Col lg={8} md={8} sm={8} xs={12}>
                  {`${carDatosContratante.cliIdentificacion} `}
                  </Col>
                </Row>
                {carDatosContratante.cliPersoneria !== undefined && carDatosContratante.cliPersoneria === "1" &&
                  <div>
                    <Row>
                  <Col lg={4} md={4} sm={4} xs={12}>
                    <h5>Nombres</h5>
                  </Col>
                  <Col lg={8} md={8} sm={8} xs={12}>
                    {`${carDatosContratante.cliNombre1} ${carDatosContratante.cliNombre2}`}
                  </Col>
                </Row>
                <Row>
                  <Col lg={4} md={4} sm={4} xs={12}>
                    <h5>Apellidos</h5>
                  </Col>
                  <Col lg={8} md={8} sm={8} xs={12}>
                    {`${carDatosContratante.cliApellido1} ${carDatosContratante.cliApellido2}`}
                  </Col>
                </Row>

                <Row>
                  <Col lg={4} md={4} sm={4} xs={12}>
                    <h5>Estado Civil</h5>
                  </Col>
                  <Col lg={8} md={8} sm={8} xs={12}>
                    {`${carDatosContratante.cliEstadoCivil} `}
                  </Col>
                </Row>
                <Row>
                  <Col lg={4} md={4} sm={4} xs={12}>
                    <h5>Género</h5>
                  </Col>
                  <Col lg={8} md={8} sm={8} xs={12}>
                    {`${carDatosContratante.cliGenero} `}
                  </Col>
                </Row>
                  </div>
                }
                {carDatosContratante.cliPersoneria !== undefined && carDatosContratante.cliPersoneria === "2" &&
                  <div>
                      <Row>
                      <Col lg={4} md={4} sm={4} xs={12}>
                        <h5>Razón Social</h5>
                      </Col>
                      <Col lg={8} md={8} sm={8} xs={12}>
                        {`${carDatosContratante.cliRazonSocial}`}
                      </Col>
                    </Row>
                  </div>
                }



                                        <Row>
                  <Col lg={4} md={4} sm={4} xs={12}>
                    <h5>Provincia</h5>
                  </Col>
                  <Col lg={8} md={8} sm={8} xs={12}>
                  {`${carDatosContratante.cliProvincia} `}
                                        </Col>
                                        </Row>


                                        <Row>
                  <Col lg={4} md={4} sm={4} xs={12}>
                    <h5>Ciudad</h5>
                  </Col>
                  <Col lg={8} md={8} sm={8} xs={12}>
                  {`${carDatosContratante.cliCiudad} `}
                                        </Col>
                                        </Row>


                                        <Row>
                  <Col lg={4} md={4} sm={4} xs={12}>
                    <h5>Fecha nacimiento</h5>
                  </Col>
                  <Col lg={8} md={8} sm={8} xs={12}>
                        
                  {`${carDatosContratante.cliFechaNacimiento} `}
                       
                      </Col>
                    </Row>

                <Row>
                  <Col lg={4} md={4} sm={4} xs={12}>
                    <h5>Correo Electrónico</h5>
                  </Col>
                  <Col lg={8} md={8} sm={8} xs={12}>
                  {`${carDatosContratante.cliEmail} `}
                  </Col>
                  <Col lg={4} md={4} sm={4} xs={12}>
                    <h5>Dirección</h5>
                  </Col>
                  <Col lg={8} md={8} sm={8} xs={12}>
                  {`${carDatosContratante.cliDireccion} `}
                  </Col>
                </Row>
                <Row>
                  <Col lg={4} md={4} sm={4} xs={12}>
                    <h5>Celular</h5>
                  </Col>
                  <Col lg={8} md={8} sm={8} xs={12}>
                  {`${carDatosContratante.cliCelular} `}
                  </Col>
                </Row>
                
              </CardBody>
            </Card>
         







            <Card className="flex-row ">
              <CardBody>


                <Row>
                  <Col lg={8} md={8} sm={8} xs={12}>
                    <h4 style={{ fontWeight: "bold" }}>Datos de Facturación</h4>
                    <p />
                  </Col>

                </Row>

                <Row style={{display:"none"}}>
                  <Col lg={4} md={4} sm={4} xs={12}>
                    <h5>Seleccione personería</h5>
                  </Col>
                  <Col lg={8} md={8} sm={8} xs={12}>
               {`${carDatosPagadorFacturacion.cliNombre1} ${carDatosPagadorFacturacion.cliNombre2}`}
                                        </Col>
                                        </Row>



                                        <Row>
                  <Col lg={4} md={4} sm={4} xs={12}>
                    <h5>Tipo de documento</h5>
                  </Col>
                  <Col lg={8} md={8} sm={8} xs={12}>
                  {`${carDatosPagadorFacturacion.cliTipoDocumento} `}
                                        </Col>
                                        </Row>


                <Row>
                  <Col lg={4} md={4} sm={4} xs={12}>
                    <h5>Número de Identificación</h5>
                  </Col>
                  <Col lg={8} md={8} sm={8} xs={12}>
                  {`${carDatosPagadorFacturacion.cliIdentificacion} `}
                  </Col>
                </Row>
                {carDatosPagadorFacturacion.cliPersoneria !== undefined && carDatosPagadorFacturacion.cliPersoneria === "1" &&
                  <div>
                      <Row>
                        <Col lg={4} md={4} sm={4} xs={12}>
                          <h5>Nombres</h5>
                        </Col>
                        <Col lg={8} md={8} sm={8} xs={12}>
                          {`${carDatosPagadorFacturacion.cliNombre1} ${carDatosPagadorFacturacion.cliNombre2}`}
                        </Col>
                      </Row>
                      <Row>
                        <Col lg={4} md={4} sm={4} xs={12}>
                          <h5>Apellidos</h5>
                        </Col>
                        <Col lg={8} md={8} sm={8} xs={12}>
                          {`${carDatosPagadorFacturacion.cliApellido1} ${carDatosPagadorFacturacion.cliApellido2}`}
                        </Col>
                      </Row>

                      <Row>
                        <Col lg={4} md={4} sm={4} xs={12}>
                          <h5>Estado Civil</h5>
                        </Col>
                        <Col lg={8} md={8} sm={8} xs={12}>
                          {`${carDatosPagadorFacturacion.cliEstadoCivil} `}
                        </Col>
                      </Row>
                      <Row>
                        <Col lg={4} md={4} sm={4} xs={12}>
                          <h5>Género</h5>
                        </Col>
                        <Col lg={8} md={8} sm={8} xs={12}>
                          {`${carDatosPagadorFacturacion.cliGenero} `}
                        </Col>
                      </Row>
                  </div>
                }
                
                {carDatosPagadorFacturacion.cliPersoneria !== undefined && carDatosPagadorFacturacion.cliPersoneria === "2" &&
                  <div>
                     <Row>
                      <Col lg={4} md={4} sm={4} xs={12}>
                        <h5>Razón Social</h5>
                      </Col>
                      <Col lg={8} md={8} sm={8} xs={12}>
                        {`${carDatosPagadorFacturacion.cliRazonSocial}`}
                      </Col>
                    </Row>
                  </div>
                }



                                        <Row>
                  <Col lg={4} md={4} sm={4} xs={12}>
                    <h5>Provincia</h5>
                  </Col>
                  <Col lg={8} md={8} sm={8} xs={12}>
                  {`${carDatosPagadorFacturacion.cliProvincia} `}
                                        </Col>
                                        </Row>


                                        <Row>
                  <Col lg={4} md={4} sm={4} xs={12}>
                    <h5>Ciudad</h5>
                  </Col>
                  <Col lg={8} md={8} sm={8} xs={12}>
                  {`${carDatosPagadorFacturacion.cliCiudad} `}
                                        </Col>
                                        </Row>


                                        <Row>
                  <Col lg={4} md={4} sm={4} xs={12}>
                    <h5>Fecha nacimiento</h5>
                  </Col>
                  <Col lg={8} md={8} sm={8} xs={12}>
                        
                  {`${carDatosPagadorFacturacion.cliFechaNacimiento} `}
                       
                      </Col>
                    </Row>

                <Row>
                  <Col lg={4} md={4} sm={4} xs={12}>
                    <h5>Correo Electrónico</h5>
                  </Col>
                  <Col lg={8} md={8} sm={8} xs={12}>
                  {`${carDatosPagadorFacturacion.cliEmail} `}
                  </Col>
                  <Col lg={4} md={4} sm={4} xs={12}>
                    <h5>Dirección</h5>
                  </Col>
                  <Col lg={8} md={8} sm={8} xs={12}>
                  {`${carDatosPagadorFacturacion.cliDireccion} `}
                  </Col>
                </Row>
                <Row>
                  <Col lg={4} md={4} sm={4} xs={12}>
                    <h5>Celular</h5>
                  </Col>
                  <Col lg={8} md={8} sm={8} xs={12}>
                  {`${carDatosPagadorFacturacion.cliCelular} `}
                  </Col>
                </Row>
                
              </CardBody>
            </Card>



          </Col>

          <Col lg={4} md={12} sm={12} xs={12} className="detalle-impuestos-box">
            <Card className="flex-row div-flotante">
            {this.props.datosCarrito.productosCarrito.valorTotal !== undefined && 
              <ValoresCotizacion formEditado={false} paso={"final-cotizacion"} metodo={this.metodo} valorTotal={this.props.datosCarrito.productosCarrito.valorTotal}></ValoresCotizacion>
            }
            </Card>
          </Col>
        </Row>
      </Page>
    );
  }
}

export default withRouter(Cotizacion5ConfirmacionFinalError);
